import React from 'react';

import DatePicker, { registerLocale } from 'react-datepicker';
import { enGB, de, fr, it } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';

import { MainBtn } from '../../Common/form/Elements-export';
import { workTimeSelectOptions, formatHolidayDate } from '../../Common/Helpers';
import { defaultDayHours } from '../../Common/work-time-pharmacy/weekdays';
import Svgs from '../../Common/Svgs';

import localStorage from '../../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

registerLocale('en', enGB);
registerLocale('de', de);
registerLocale('fr', fr);
registerLocale('it', it);

class WorkTimeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            workTimeValues: { ...this.props.workTimeValues },
            daysOff: this.props.daysOffValues,
            language: this.props.language,
            lunchBreaks: this.props.lunchBreaks,
            isCreate: this.props.isCreate,
            activeTab: 'work_time_tab'
        };
    }

    generateSpecialHoursSelect = (dateObj, index, hoursIndex, type, hasLunchBreak) => {
        let disabled = dateObj.dayOff ? 'qf-disabled' : '';

        return (
            <div className="formSelect col-1 pl-0 mb-0 qf-min-80 qf-max-100">
                { hoursIndex === 0 || hasLunchBreak ?
                <div className="selectWrapper">
                    <select
                        className={disabled}
                        name={hoursIndex + '_' + type}
                        value={dateObj.workTime[hoursIndex][type]}
                        disabled={dateObj.dayOff}
                        onChange={this.props.updateSpecialDate(index, 'workTime', hoursIndex, type)}
                    >
                        {workTimeSelectOptions()}
                    </select>
                </div>
                : ''}
            </div>
        )
    };

    generateSpecialDatesList = () => {
        return (
            <div className="pt-2" ref="datepickerRef">
                {this.state.workTimeValues.specialDates.map((dateObj, index) => {

                    let disabled = dateObj.dayOff ? 'qf-disabled' : '',
                        hasLunchBreak = dateObj.lunchBreak ? 'checked' : '',
                        hasDayOff = dateObj.dayOff ? 'checked' : '',
                        formatedDate = dateObj.date && (new Date(dateObj.date)) !== 'Invalid Date' ? new Date(dateObj.date) : null;

                    // *** !!! DO NOT USE moment.js - react-datepicker(from v2.0.0) switched to using native Date objects to reduce the size of the package. !!! ***
                    
                    return (
                        <div className="row mt-1" key={index}>
                            <div className="formInput col-2 mb-0 qf-min-170">
                                <i className="fa fa-calendar qf-input-calendar-icon" />
                                <DatePicker
                                    locale={localStorage.getFromStorage('lang')}
                                    className={disabled}
                                    selected={formatedDate}
                                    placeholderText={strings.Pick_a_date}
                                    onChange={this.props.updateSpecialDate(index, 'date')}
                                    disabled={dateObj.dayOff}
                                    dateFormat="dd/MM/yyyy"
                                />
                            </div>
                            <div className="formInput col-1 pl-0 qf-min-150">
                                <input
                                    type="text"
                                    name="special_date_name"
                                    placeholder={strings.enter_name}
                                    value={dateObj.name}
                                    onChange={this.props.updateSpecialDate(index, 'name')}
                                />
                            </div>
                            {this.generateSpecialHoursSelect(dateObj, index, 0, 'from', hasLunchBreak)}
                            {this.generateSpecialHoursSelect(dateObj, index, 0, 'to', hasLunchBreak)}
                            {this.generateSpecialHoursSelect(dateObj, index, 1, 'from', hasLunchBreak)}
                            {this.generateSpecialHoursSelect(dateObj, index, 1, 'to', hasLunchBreak)}

                            <div className="col-1 p-0 text-center">
                                <input
                                    className="qf-cursor-pointer qf-custom-checkbuttons"
                                    type="checkbox"
                                    onChange={this.props.handleSpecialLunchBreak(index)}
                                    checked={hasLunchBreak}
                                />
                            </div>
                            <div className="col-1 p-0 text-center">
                                <input
                                    className="qf-cursor-pointer qf-custom-checkbuttons"
                                    type="checkbox"
                                    onChange={this.props.handleSpecialDayOff(index)}
                                    checked={hasDayOff}
                                />
                            </div>
                            <div className="col-1 p-0 text-center qf-max-40">
                                <button type="button" className="qf-custom-btn p-0"
                                        onClick={(index) => this.props.removeSpecialDateRow(index)}>
                                    <i className="fa fa-trash-o qf-delete-btn-icon" />
                                    {/* <span className="pl-2 qf-text-dark-gray">{strings.delete}</span> */}
                                </button>
                                
                            </div>

                            <div className="col-12 mb-2 small">{this.props.generateErrorsMessages(this.props.workTimeValues.specialDates[index].error)}</div>
                            
                        </div>
                    )
                })}
            </div>
        )
    };

    generateHoursSelect = (dayName, index, type, selectName, dayOff, disabled, hasLunchBreak, defaultValue) => {

        return (
            <div className="formSelect col-2 qf-min-100 qf-max-110">
                { index === 0 || hasLunchBreak ?
                <div className="selectWrapper">
                    <select
                        className={disabled}
                        name={selectName}
                        value={defaultValue}
                        disabled={dayOff}
                        onChange={this.props.updateDatesOfWeek(dayName, index, type)}
                    >
                        {workTimeSelectOptions()}
                    </select>
                </div>
                : ''}
            </div>
        )
    };

    generateWorkTimeRow(dayName, additionalRowClass, defaultValues = defaultDayHours, dayOff = false, lunchBreak = false) {
        let hasDayOff = dayOff ? 'checked' : '',
            disabled = dayOff ? 'qf-disabled' : '',
            hasLunchBreak = lunchBreak ?  'checked' : '';

        return (
            <div className={'row ' + additionalRowClass}>
                <div className="col-2 text-capitalize color-dark-gray qf-min-170">{strings[dayName]}</div>

                {this.generateHoursSelect(dayName, 0, 'from', dayName + '_from_1', dayOff, disabled, hasLunchBreak, defaultValues[0])}
                {this.generateHoursSelect(dayName, 0, 'to', dayName + '_to_1', dayOff, disabled, hasLunchBreak, defaultValues[1])}
                {this.generateHoursSelect(dayName, 1, 'from', dayName + '_from_2', dayOff, disabled, hasLunchBreak, defaultValues[2])}
                {this.generateHoursSelect(dayName, 1, 'to', dayName + '_to_2', dayOff, disabled, hasLunchBreak, defaultValues[3])}

                <div className="col-1 text-center qf-min-100">
                    <input
                        className="qf-cursor-pointer qf-custom-checkbuttons"
                        type="checkbox"
                        onChange={this.props.handleLunchBreak(dayName)}
                        defaultChecked={hasLunchBreak}
                    />
                </div>
                <div className="col-1 text-center qf-min-100">
                    <input
                        className="qf-cursor-pointer qf-custom-checkbuttons"
                        type="checkbox"
                        onChange={this.props.daysOffHandler(dayName)}
                        defaultChecked={hasDayOff}
                    />
                </div>
            </div>
        );
    };

    returnHoursOfCurrentDay = day => {
        let hoursOfTheDay = [];

        if (this.state.workTimeValues.weekDays[day][0] !== undefined && this.state.workTimeValues.weekDays[day][1] !== undefined) {
            hoursOfTheDay.push(this.state.workTimeValues.weekDays[day][0]['from']);
            hoursOfTheDay.push(this.state.workTimeValues.weekDays[day][0]['to']);
            hoursOfTheDay.push(this.state.workTimeValues.weekDays[day][1]['from']);
            hoursOfTheDay.push(this.state.workTimeValues.weekDays[day][1]['to']);
        }

        return hoursOfTheDay;
    };

    returnAreasOfDelivery = () => {
        return this.state.workTimeValues['areasOfDelivery' + this.state.language[0].toUpperCase() + this.state.language[1]];
    };

    returnPlaceholderAreasOfDelivery = () => {
        return this.state.isCreate ? strings['areas_of_delivery_text_' + this.state.language] : '';
    };

    generateHeaderColumn = (title, extraClasses) => {
        return (
            <div className={'qf-work-time-title ' + extraClasses}>
                <label>{title}</label>
            </div>
        )
    };

    generateLanguageButton = (language) => {
        return (
            <label className="qf-tab-lang-label">
                <input
                    className="qf-tab-lang-input"
                    type="radio" name="lang-tabs"
                    value={language}
                    checked={this.state.language === language}
                    onChange={this.props.updateLanguage("language")}
                />
                <span className="text-uppercase">{language}</span>
            </label>
        )
    };

    switchTabs = selectedTab => {
        if (this.state.activeTab !== selectedTab) {
            this.setState({ ...this.state, activeTab: selectedTab });
        }
    };

    fetchIcon = tabName => {
        switch (tabName) {
            case 'work_time_tab':
                return <i className="fa fa-clock-o mr-1" />;
            case 'special_days_tab':
                return Svgs.calendarCheck;
            case 'national_holidays_tab':
                return Svgs.calendarStar;
            default:
                return '';
        }
    };

    generateTabLabel = tabName => {
        return (
            <label className="qf-tab-label">
                <input
                    className="qf-tab-input"
                    type="radio" name="tabs"
                    value={tabName}
                    checked={this.state.activeTab === tabName}
                    onChange={() => this.switchTabs(tabName)}
                />
                <span className="">
                    {this.fetchIcon(tabName)}
                    {strings[tabName]}
                </span>
            </label>
        )
    };

    componentWillReceiveProps(nextProps) {
        //console.log('componentWillReceiveProps', nextProps);
        this.setState({
            ...this.state,
            workTimeValues: nextProps.workTimeValues,
            daysOff: nextProps.daysOffValues,
            language: nextProps.language,
            lunchBreaks: nextProps.lunchBreaks
        });
    }
    
    getDerivedStateFromProps(nextProps, prevState){
        //console.log('getDerivedStateFromProps', nextProps, prevState);
        // if(nextProps.someValue !== prevState.someValue){
        //     return { someState: nextProps.someValue};
        // }
        // else return null;
    }
    
    componentDidUpdate(prevProps, prevState) {
        //console.log('componentDidUpdate', prevProps, prevState);
        // if(prevProps.someValue!==this.props.someValue){
        //     //Perform some operation here
        //     this.setState({someState: someValue});
        //     this.classMethod();
        // }
    }

    showBlock = name => {
        if (name !== this.state.activeTab) {
            return 'qf-hide';
        } else {
            return '';
        }
    };

    generateHolidaysSelect = (holidayObj, index, hoursIndex, type, hasLunchBreak) => {
        let disabled = holidayObj.dayOff ? 'qf-disabled' : '';

        return (
            <div className="formSelect col-1 qf-min-100 qf-max-110">
                { hoursIndex === 0 || hasLunchBreak ?
                <div className="selectWrapper">
                    <select
                        className={disabled}
                        name={hoursIndex + '_' + type}
                        value={holidayObj.workTime[hoursIndex][type]}
                        disabled={holidayObj.dayOff}
                        onChange={this.props.updateHoliday(index, 'workTime', hoursIndex, type)}
                    >
                        {workTimeSelectOptions()}
                    </select>
                </div>
                : ''}
            </div>
        );
    };

    generateNationalHolidaysList = (active, holidayName, additionalRowClass, defaultValues = defaultDayHours, dayOff = false, lunchBreak = false) => {
        
        return (
            <div className="pt-2">
                {this.state.workTimeValues.nationalHolidays.map((holiday, index) => {
                    let hasLunchBreak = holiday.lunchBreak ? 'checked' : '';

                    return (
                        <div className="row mt-1" key={index}>
                            <div className="col-1 text-center">
                                <input
                                    className="qf-cursor-pointer qf-custom-checkbuttons"
                                    type="checkbox"
                                    onChange={this.props.updateHoliday(index, 'active')}
                                    defaultChecked={holiday.active}
                                />
                            </div>
                            <div className="col-5 mb-2 text-capitalize color-dark-gray qf-max-160">
                                <p className="qf-holiday-name">{holiday.name}</p>
                                {/* <span className="qf-holiday-date">{formatDate(holiday.date, false)}</span> */}
                                <span className="qf-holiday-date">{formatHolidayDate(holiday.date, 'DD-MM-YYYY')}</span>
                            </div>

                            {this.generateHolidaysSelect(holiday, index, 0, 'from', hasLunchBreak)}
                            {this.generateHolidaysSelect(holiday, index, 0, 'to', hasLunchBreak)}
                            {this.generateHolidaysSelect(holiday, index, 1, 'from', hasLunchBreak)}
                            {this.generateHolidaysSelect(holiday, index, 1, 'to', hasLunchBreak)}

                            <div className="col-1 text-center qf-max-80">
                                <input
                                    className="qf-cursor-pointer qf-custom-checkbuttons"
                                    type="checkbox"
                                    onChange={this.props.handleHolidayLunchBreak(index)}
                                    defaultChecked={holiday.lunchBreak}
                                />
                            </div>
                            <div className="col-1 text-center qf-max-80">
                                <input
                                    className="qf-cursor-pointer qf-custom-checkbuttons"
                                    type="checkbox"
                                    onChange={this.props.handleHolidayDayOff(index)}
                                    defaultChecked={holiday.dayOff}
                                />
                            </div>

                        </div>
                    )
                })}
            </div>
        )
    };

    render() {
        return (
            <div id="workTimeModal">
                <div className="modal-header mb-4">
                    <h5 className="modal-title">
                        <i className="fa fa-clock-o mr-3" />
                        {strings.Work_time_editor}
                    </h5>
                </div>
                <div className="modal-body">

                    <div className="row">
                        <div className="col-12 mb-4">
                            <div className="qf-worktime-tabs-wrapper d-flex justify-content-between align-items-start">
                                <div>
                                    {this.generateTabLabel('work_time_tab')}
                                    {this.generateTabLabel('special_days_tab')}
                                    {this.generateTabLabel('national_holidays_tab')}
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div className={'row ' + this.showBlock('work_time_tab')}>
                        <div className="col-12 pl-4 qf-modal-content">

                            <div className="row">
                                <div className="col-12">
                                    <div className="qf-lang-tabs-wrapper mb-2">
                                        {this.generateLanguageButton('en')}
                                        {this.generateLanguageButton('de')}
                                        {this.generateLanguageButton('fr')}
                                        {this.generateLanguageButton('it')}
                                    </div>
                                </div>
                            </div>

                            <div className="formInput row">
                                <div className="col-2 color-dark-gray">{strings.areas_of_delivery_time}</div>
                                <div className="col-10">
                                    <input
                                        type="text"
                                        name="areas_of_delivery"
                                        placeholder={this.returnPlaceholderAreasOfDelivery()}
                                        value={this.returnAreasOfDelivery()}
                                        onFocus={this.props.handleFocusInput}
                                        onBlur={this.props.handleBlurInput}
                                        onChange={this.props.updateAreasOfDelivery()}
                                    />
                                    <div className="col-12">{this.props.generateErrorsMessages(this.props.validation.areasOfDelivery)}</div>
                                </div>
                            </div>

                            <div className="formInput row workTimeLabels">
                                {this.generateHeaderColumn(strings.Day, 'col-2 qf-min-170')}
                                {this.generateHeaderColumn(strings.Work_from, 'col-2 qf-min-100 qf-max-110')}
                                {this.generateHeaderColumn(strings.Work_to, 'col-2 qf-min-100 qf-max-110')}
                                {this.generateHeaderColumn(strings.Work_from, 'col-2 qf-min-100 qf-max-110')}
                                {this.generateHeaderColumn(strings.Work_to, 'col-2 qf-min-100 qf-max-110')}
                                {this.generateHeaderColumn(strings.Lunch_Break, 'col-1 p-0 qf-min-100 text-center')}
                                {this.generateHeaderColumn(strings.Day_Off, 'col-1 p-0 qf-min-100 text-center')}
                            </div>

                            {this.generateWorkTimeRow('monday', 'mb-1', this.returnHoursOfCurrentDay('mon'), this.state.daysOff.mon, this.state.lunchBreaks.mon)}
                            {this.generateWorkTimeRow('tuesday', 'mb-1', this.returnHoursOfCurrentDay('tue'), this.state.daysOff.tue, this.state.lunchBreaks.tue)}
                            {this.generateWorkTimeRow('wednesday', 'mb-1', this.returnHoursOfCurrentDay('wed'), this.state.daysOff.wed, this.state.lunchBreaks.wed)}
                            {this.generateWorkTimeRow('thursday', 'mb-1', this.returnHoursOfCurrentDay('thu'), this.state.daysOff.thu, this.state.lunchBreaks.thu)}
                            {this.generateWorkTimeRow('friday', 'mb-4', this.returnHoursOfCurrentDay('fri'), this.state.daysOff.fri, this.state.lunchBreaks.fri)}
                            {this.generateWorkTimeRow('saturday', 'mb-1', this.returnHoursOfCurrentDay('sat'), this.state.daysOff.sat, this.state.lunchBreaks.sat)}
                            {this.generateWorkTimeRow('sunday', 'mb-4', this.returnHoursOfCurrentDay('sun'), this.state.daysOff.sun, this.state.lunchBreaks.sun)}

                        </div>
                    </div>


                    <div className={'row ' + this.showBlock('special_days_tab')}>
                        <div className="col-12 pl-4 qf-modal-content">
                            <div className="formInput row">
                                <div className="col-12 pt-4 text-right">
                                    <MainBtn
                                        title={'+ ' + strings.Add_date}
                                        onclick={this.props.addNewSpecialDateRow}
                                        extraClasses="qf-add-item-button" />
                                </div>
                            </div>
                            {this.props.workTimeValues.specialDates.length !== 0 ? (
                                <div className="formInput row workTimeLabels">
                                    {this.generateHeaderColumn(strings.Date, 'col-2 qf-min-170')}
                                    {this.generateHeaderColumn(strings.Name, 'col-1 p-0 qf-min-150')}
                                    {this.generateHeaderColumn(strings.Work_from, 'col-1 p-0 qf-min-80 qf-max-100')}
                                    {this.generateHeaderColumn(strings.Work_to, 'col-1 p-0 qf-min-80 qf-max-100')}
                                    {this.generateHeaderColumn(strings.Work_from, 'col-1 p-0 qf-min-80 qf-max-100')}
                                    {this.generateHeaderColumn(strings.Work_to, 'col-1 p-0 qf-min-80 qf-max-100')}
                                    {this.generateHeaderColumn(strings.Lunch_Break, 'col-1 p-0 text-center')}
                                    {this.generateHeaderColumn(strings.Day_Off, 'col-1 p-0 text-center')}
                                    {this.generateHeaderColumn('', 'col-1 p-0 text-right qf-max-40')}
                                </div>
                            ) : null}
                            {this.generateSpecialDatesList()}
                        </div>
                    </div>


                    <div className={'row ' + this.showBlock('national_holidays_tab')}>
                        <div className="col-12 pl-4 qf-modal-content">
                            
                            <div className="formInput row workTimeLabels">
                                {this.generateHeaderColumn(strings.active, 'col-1')}
                                {this.generateHeaderColumn(strings.holiday, 'col-5 qf-min-100 qf-max-160')}
                                {this.generateHeaderColumn(strings.Work_from, 'col-1 qf-min-100 qf-max-110')}
                                {this.generateHeaderColumn(strings.Work_to, 'col-1 qf-min-100 qf-max-110')}
                                {this.generateHeaderColumn(strings.Work_from, 'col-1 qf-min-100 qf-max-110')}
                                {this.generateHeaderColumn(strings.Work_to, 'col-1 qf-min-100 qf-max-110')}
                                {this.generateHeaderColumn(strings.Lunch_Break, 'col-1 p-0 qf-max-80 text-center')}
                                {this.generateHeaderColumn(strings.Day_Off, 'col-1 p-0 qf-max-80 text-center')}
                            </div>


                            {this.generateNationalHolidaysList()}

                        </div>

                    </div>
    
                    <div className="formInput row mt-5">
                        <div className="formSelect col-3 offset-9">
                            <MainBtn onclick={this.props.updateWorkTime} title={strings.Save} extraClasses="qf-blue-btn w-100" />
                        </div>
                    </div>
                    
                </div>
            </div>
        );
    }
}

export default WorkTimeModal;



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/components/WorkTimeModal.js